import React, { type FC } from 'react';
import { DynamicFieldset, FieldTypes, Link, Radio } from '@g2u/ui-kit';
import { Spin, Collapse, type FormInstance, Form } from 'antd';
import { observer } from 'mobx-react-lite';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import { Content, Section } from 'components';
import styles from '../cancel.module.scss';

enum ReasonsGroup {
  Customer = 'Customer',
  Technician = 'Technician',
  CSS = 'CSS',
  Other = 'Other',
}
export namespace SelectCancelReason {
  export type Props = {
    form: FormInstance;
    isReasonsLoading: boolean;
    reasons?: JsonDataItem;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { isReasonsLoading, reasons = {}, form } = props;
    Form.useWatch([], { form });

    return (
      <Section.$ title="Select a Reason" noPadding={!isReasonsLoading}>
        {isReasonsLoading ? (
          <Spin />
        ) : (
          <>
            <Collapse
              defaultActiveKey={Object.keys(reasons)[0]}
              ghost
              destroyInactivePanel
              className={styles.cancel__reason}
              items={Object.keys(reasons)
                .filter((name) => name !== ReasonsGroup.Other)
                .map((reason: string) => {
                  return {
                    key: reason,
                    label: <Link.$ className={styles.cancel__reasonTitle}>{reason} </Link.$>,
                    children: (
                      <Radio.$
                        name="reason"
                        columns={1}
                        options={reasons[reason].map((option: JsonDataItem) => {
                          return {
                            label: option.description,
                            value: option.ID,
                          };
                        })}
                      />
                    ),
                  };
                })}
            />
            <Content.$ dataTestId="job-cancelation-page" className={styles.cancel__reasonOther}>
              <Radio.$
                name="reason"
                columns={1}
                options={reasons[ReasonsGroup.Other].map((option: JsonDataItem) => {
                  return {
                    label: option.description,
                    value: option.ID,
                  };
                })}
              />
              <DynamicFieldset.$
                dataTestId="other-description"
                form={form}
                fields={[
                  {
                    required: true,
                    rules: [{ required: true }],
                    conditions: [{ name: 'reason', value: 6 }], // 6 according to DB
                    type: FieldTypes.TextArea,
                    name: 'description',
                    label: 'Please provide details below:',
                    value: undefined,
                  },
                ]}
              />
            </Content.$>
          </>
        )}
      </Section.$>
    );
  });
}
